jQuery(function() {
	
		var myCustomSlider = document.querySelectorAll('.mySwiper2');
		var myCustomGalleryThumbs = document.querySelectorAll('.mySwiper');

		for (i = 0; i < myCustomSlider.length; i++) {

			myCustomSlider[i].classList.add('gallery-top-' + i);
			myCustomGalleryThumbs[i].classList.add('thumbs-class-' + i);

			var galleryThumbs = new Swiper('.thumbs-class-' + i , {
					slidesPerView: 8,
					freeMode: true,
					watchSlidesVisibility: true,
					watchSlidesProgress: true,
			});

			var galleryTop = new Swiper('.gallery-top-' + i, {
					spaceBetween: 10,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev"
					},
					thumbs: {
							swiper: galleryThumbs
					}
			}); 

		}
	
})